// extracted by mini-css-extract-plugin
export default {"area":"CardActionArea_area__2OpIV"};